import React from 'react';

const CONTACTO_ICONO = '✉️'; 

const  BotonEnlace = ({ url, texto }) => {
  return (
    <a 
      href={url} 
      target="_blank" 
      rel="noopener noreferrer" 
      className="contactsend" // Para darle estilos de botón
        style={{
          // Estilos para hacerlo flotante y visible         className="scroltop"
          position: 'fixed', // Fija el elemento en la ventana
          bottom: '66px',    // Distancia desde abajo
          right: '4px',     // Distancia desde la derecha
          zIndex: 999,      // Asegura que esté por encima de otros elementos
          // Estilos gráficos del botón
          width: '60px',
          height: '60px',
          borderRadius: '50%', // Lo hace redondo
          backgroundColor: 'rgba(130, 130, 130)',
          color: 'white',
          fontSize: '24px',
          border: 'none',
          cursor: 'pointer',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          
        }}
    >
      {CONTACTO_ICONO} 
    </a>
  );
};

export default BotonEnlace;

